// --- Constants ---
export const WEBSITE_NAME = 'trackcopr.com';

// --- Watermark Function (for ECharts) ---
/**
 * Generates an ECharts graphic element configuration for a watermark.
 * To be merged into the `graphic` array within ECharts options.
 * @returns {object} ECharts graphic element configuration object.
 */
export const getEchartsWatermark = () => {
    return {
        type: 'text',
        left: 'center',
        top: 'center',
        zlevel: 1, // Place watermark between grid (zlevel 0) and series (zlevel 2)
        style: {
            text: WEBSITE_NAME,
            font: 'bold 30px Arial', // Adjust font size as needed, maybe make dynamic later
            fill: 'rgba(255, 0, 0, 0.15)', // Lighter, less intrusive red
            textAlign: 'center',
            textVerticalAlign: 'middle',
            // Rotation is handled by `rotation` property
        },
        rotation: -Math.PI / 6, // Rotate -30 degrees
        // Make watermark non-interactive
        silent: true,
        // Ensure it doesn't trigger events
        triggerEvent: false,
    };
};

// --- Download Handler (for ECharts) ---
// (To be implemented in the next step)
export const handleEchartsDownload = (echartsInstance, chartName, filterName = 'all') => {
    if (!echartsInstance) {
        console.error("ECharts instance not found for downloading.");
        alert("Could not get chart data to download.");
        return;
    }

    try {
        const base64Image = echartsInstance.getDataURL({
            type: 'png',
            pixelRatio: 2, // Increase resolution for better quality
            backgroundColor: '#fff' // Set background color to white
        });

        const link = document.createElement('a');
        link.href = base64Image;
        // Sanitize filterName for filename
        const safeFilterName = filterName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        const filename = `${chartName.toLowerCase().replace(/ /g, '-')}-chart${safeFilterName ? `-${safeFilterName}` : ''}.png`;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    } catch (error) {
        console.error("Error generating or downloading ECharts image:", error);
        alert("Sorry, couldn't download the chart image.");
    }
};